export default function(x) {
  var r = Math.exp(x);
  r = (r + 1 / r) / 2;
  return r;
}


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/web/app/themes/wz/node_modules/proj4/lib/common/cosh.js
// module id = 224
// module chunks = 0